<app-login [user]="user$ | async"> </app-login>
